import * as types from 'model/actionTypes'

export function receiveMattertag (tourSlotId: string, mattertagId: string) {
  return {
    type: types.RECEIVE_MATTERTAG,
    tourSlotId,
    mattertagId
  }
}
